import { formatNum } from '../../../Helpers/format-phone-number';
import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import {
  httpCreateCompany,
  httpCompanyLogo,
} from '../../../Hooks/admin/admin.post.hooks';
import { SubmitContainer, TopSubmit, BottomSubmit } from '../CreateForm.styles';
// import { createCompany } from '../../../Utils/Companies/postCompany';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const PrimaryButton = React.lazy(
  () =>
    import('../../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const Loader = React.lazy(
  () => import('../../../Components/Loader/LoaderComponent.component')
);

const CreateCompanySubmit = ({
  company,
  image,
  result,
  setResult,
  setIsOpen,
  disabled,
  billingAddress,
}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (formattedCompany) => httpCreateCompany(formattedCompany),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['companies']);
      setResult(message.msg || 'Company has been created');
      setIsOpen(true);
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error creating company:', error);
      setResult(err.msg || 'Failed to create company');
      setIsOpen(true);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formattedCompany = {
      ...company,
      phoneOffice: formatNum(company.phoneOffice),
      phoneMobile: formatNum(company.phoneMobile),
      address: billingAddress,
      logo: image,
    };
    mutation.mutate(formattedCompany);
    if (image) {
      const formData = new FormData();
      formData.append('logo', image);
      formData.append('company', formattedCompany.companyName);
      const res = await httpCompanyLogo(formData);
      if (res.ok) {
        setResult('Company has been created with logo');
      } else {
        setResult(
          'An error occurred while creating the company, issue with logo, rest of company has been created'
        );
      }
    }
  };

  return (
    <Suspense fallback={<p>Loading submit components...</p>}>
      <SubmitContainer>
        {mutation.isPending ? (
          <Loader />
        ) : (
          <>
            <TopSubmit>
              {result.length > 0 && <p className="result">{result}</p>}
            </TopSubmit>
            <BottomSubmit>
              <PrimaryButton
                functionName={handleSubmit}
                span="Create Company"
                disabled={!disabled}
              />
            </BottomSubmit>
          </>
        )}
      </SubmitContainer>
    </Suspense>
  );
};

CreateCompanySubmit.propTypes = {
  company: PropTypes.object,
  image: PropTypes.string,
  result: PropTypes.string,
  setResult: PropTypes.func,
  setIsOpen: PropTypes.func,
  disabled: PropTypes.bool,
  billingAddress: PropTypes.object,
};

export default CreateCompanySubmit;
